export default __webpack_public_path__ + "static/assets/56de970ff3c5b482f289836bbf75158b.svg";